/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

export function services() {
  $('.services__tabContent').hide();
  $('.services__tabContent.active').show();

  $('.services__tab').on('click tap', function() {
    $('.services__tab').removeClass('active');
    $(this).addClass('active');
    var target = $(this).attr('data-tab-id');
    $('.services__tabContent').hide();
    $('.services__tabContent[data-tab-name=' + target + ']').show();
  });

  if ($('.services__tab:first-of-type').hasClass('active')) {
  $('.services__tabContentContainer').addClass('first');
}

$('.services__tab').on('click tap', function () {
  if ($('.services__tab:first-of-type').hasClass('active')) {
    $('.services__tabContentContainer').addClass('first');
  } else {
    $('.services__tabContentContainer').removeClass('first');
  }

  if ($('.services__tab:last-of-type').hasClass('active')) {
    $('.services__tabContentContainer').addClass('last');
  } else {
    $('.services__tabContentContainer').removeClass('last');
  }

});

}
